import React from 'react';
import { compose, branch, renderNothing } from 'recompose';
import { Link } from 'js/components/common/Link';

import style from './index.scss';

export const TermsAndConditions = ({ termsAndConditionsUrl, className = '', text = '' }) => {
    return (
        <div className={style.container}>
            <Link
                href={termsAndConditionsUrl}
                inNewWindow={true}
                className={`${style.link} ${className}`}>
                {text}
            </Link>
        </div>
    );
};

export default compose(
    branch(
        ({ termsAndConditionsUrl }) => !termsAndConditionsUrl,
        renderNothing
    )
)(TermsAndConditions);
